<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Change Team Status ({{ company }})</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.model" class="form-wrapper">
                <form-group name="status" label="New Status">
                    <md-select v-model="model.status">
                        <md-option v-for="item in filteredStatusOptions" :key="item" :value="item">
                            {{ item }}
                        </md-option>
                    </md-select>
                </form-group>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click.stop="changeTeamStatus">Update</md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { required } from 'vuelidate/lib/validators';
import { GeneralMixin } from '@/mixins/GeneralMixin';

export default {
    name: 'ChangeTeamStatusModal',
    mixins: [GeneralMixin],
    props: {
        teamId: { type: Number, required: true },
        company: { type: String, required: true },
        teamStatus: { type: String, required: true },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            model: { status: null },
            statusOptions: [
                {
                    from: 'Disabled?',
                    options: ['Active', 'Disabling', 'Disabled']
                },
                {
                    from: 'Disabling',
                    options: ['Active', 'Disabled']
                },
                {
                    from: 'Disabled',
                    options: ['Active', 'Disabling']
                },
                {
                    from: 'Unknown',
                    options: ['Active', 'Disabling', 'Disabled']
                },
                {
                    from: 'Active',
                    options: ['Disabling', 'Disabled']
                }
            ]
        };
    },
    validations() {
        return {
            model: {
                status: {
                    required
                }
            }
        };
    },
    computed: {
        filteredStatusOptions() {
            if (!this.teamStatus) 
                return [];

            const targetStatuses = this.statusOptions.find((x) => x.from === this.teamStatus);

            if (targetStatuses) 
                return targetStatuses.options;

            this.$notify({
                message: `Changing '${this.teamStatus}' status is not allowed.`,
                type: 'warning'
            });

            return [];
        }
    },
    methods: {
        async changeTeamStatus() {
            this.$v.$touch();
            if (this.$v.$invalid) 
                return;

            this.$_handleLoaderState(true, `Updating ${this.company}'s status...`);

            try {
                const payload = {
                    method: 'post',
                    data: {
                        status: this.model.status
                    }
                };
                const api = `/api/support/teams/${this.teamId}/team-status`;
                await handleRequests(api, payload);

                this.$notify({
                    message: "Team's status was updated successfully.",
                    type: 'success'
                });

                this.resolve(this.model);
            } catch (e) {
                const message = "Could not update team's status.";
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        }
    }
};
</script>
